import React, { useState, useEffect,  useRef } from 'react';
import  axios  from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Input,Button,Tooltip,Modal,ModalBody,Table } from 'reactstrap';

const FundToken = (props) => {

    const dispatch = useDispatch()
    const selectAuthToken = state => state.apiKey
    const selectStore = state => state
    const authToken = useSelector(selectAuthToken);
    const reduxData = useSelector(selectStore);
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [file, setFile] = useState([])
    const [fileResponse, setFileResponse] = useState("")
    const didMount = useRef(false)

    useEffect(() => {
        //getTable()
    }, [])

    function fileSelect(e) {
        if (e.target.files) {
            setFile(e.target.files[0])
        }
    }

    const submitFile = async (event) => {
        event.preventDefault()
        //console.log("submit file")
        dispatch({ type: 'foundation/setFetchTime' })
        const formData = new FormData();
        formData.append("file", file);
        formData.append("filename", file.name);
        formData.append("userLevel", reduxData.userInfo.level.pk)
        let bearerVAR = "Bearer " + authToken
        if (file.name.slice(-4) == ".csv") {
            const resp = await axios.post("FundTokenUploadFile", formData, {
                headers: { 'Authorization': bearerVAR, 'content-type': 'multipart/form-data' }
            })
            setFileResponse(resp.data)
            //fetch("FundTokenUploadFile", { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: formData })
            setTimeout(() => {setFileResponse("") }, 5000)
        }
    }

    useEffect(() => {
        if (!didMount.current) {
            return didMount.current = true
        }
        if (!fileResponse) {
            return
        }
        setTimeout(() => {
            setFileResponse(false)
        }, 3000)
    }, [fileResponse])

    const toggle = () => setTooltipOpen(!tooltipOpen)
    const toggleModal = () => { setModalOpen(!modalOpen) }

    return (<div>
        <Modal isOpen={modalOpen} toggle={toggleModal} size={'xl' }>
            <ModalBody>

                <Table>
                    <thead>
                        <tr>
                            <th>Column Name</th>
                            <th>Datatype</th>
                            <th>Can Be Blank</th>
                            <th>Example</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CODE_VALUE_KEY</td>
                            <td>Maximum 10 characters</td>
                            <td>No</td>
                            <td>8175</td>
                        </tr>
                        <tr>
                            <td>CODE_VLAUE</td>
                            <td>Maximum 10 characters</td>
                            <td>No</td>
                            <td>8175</td>
                        </tr>
                        <tr>
                            <td>SHORT_DESC</td>
                            <td>Maximum 10 characters</td>
                            <td>No</td>
                            <td>8175</td>
                        </tr>
                        <tr>
                            <td>MEDIUM_DESC</td>
                            <td>Maximum 20 characters</td>
                            <td>No</td>
                            <td>UWC</td>
                        </tr>
                        <tr>
                            <td>LONG_DESC</td>
                            <td>Maximum 40 characters</td>
                            <td>No</td>
                            <td>United World College Grant</td>
                        </tr>
                        <tr>
                            <td>STATUS</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>A</td>
                        </tr>
                        <tr>
                            <td>TYPE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>F</td>
                        </tr>
                        <tr>
                            <td>AMOUNT</td>
                            <td>Decimal number, 18 numbers maximum with 6 right of point</td>
                            <td>Yes</td>
                            <td>0.000000</td>
                        </tr>
                        <tr>
                            <td>PER_CREDIT_FLAT</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>F</td>
                        </tr>
                        <tr>
                            <td>PRINT_ORDER</td>
                            <td>Three characters</td>
                            <td>No</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>GL_ACCOUNT_1</td>
                            <td>Maximum 66 characters</td>
                            <td>No</td>
                            <td>00025342001</td>
                        </tr>
                        <tr>
                            <td>DB_CR_FLAG_1</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>D</td>
                        </tr>
                        <tr>
                            <td>GL_ACCOUNT_2</td>
                            <td>Maximum 66 characters</td>
                            <td>No</td>
                            <td>00000012000</td>
                        </tr>
                        <tr>
                            <td>DB_CR_FLAG_2</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>C</td>
                        </tr>
                        <tr>
                            <td>TAXABLE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>FIN_AID_ELIGIBLE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>REFUND_ELIGIBLE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>STATEMENT_TYPE</td>
                            <td>Maximum 6 characters</td>
                            <td>No</td>
                            <td>GEN</td>
                        </tr>
                        <tr>
                            <td>SUMMARY_TYPE</td>
                            <td>Maximum 6 characters</td>
                            <td>No</td>
                            <td>FINAID</td>
                        </tr>
                        <tr>
                            <td>PROJECT_ID</td>
                            <td>Maximum 10 characters</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>EMAIL_MESSAGE</td>
                            <td>Character string of unknown length</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>STATEMENT_MESSAGE</td>
                            <td>Character string of unknown length</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>EMAIBEGINNING_BAL_FLAG</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>CREATE_DATE</td>
                            <td>Date and time</td>
                            <td>No</td>
                            <td>2022-06-29 00:00:00.000</td>
                        </tr>
                        <tr>
                            <td>CREATE_TIME</td>
                            <td>Date and time</td>
                            <td>No</td>
                            <td>1900-01-01 16:05:00.000</td>
                        </tr>
                        <tr>
                            <td>CREATE_OPID</td>
                            <td>Maximum 8 characters</td>
                            <td>No</td>
                            <td>MCCABE</td>
                        </tr>
                        <tr>
                            <td>CREATE_TERMINAL</td>
                            <td>Maximum 4 characters</td>
                            <td>No</td>
                            <td>0001</td>
                        </tr>
                        <tr>
                            <td>REVISION_DATE</td>
                            <td>Date and time</td>
                            <td>No</td>
                            <td>2022-06-29 00:00:00.000</td>
                        </tr>
                        <tr>
                            <td>REVISION_TIME</td>
                            <td>Date and time</td>
                            <td>No</td>
                            <td>1900-01-01 16:05:00.000</td>
                        </tr>
                        <tr>
                            <td>REVISION_OPID</td>
                            <td>Maximum 8 characters</td>
                            <td>No</td>
                            <td>MCCABE</td>
                        </tr>
                        <tr>
                            <td>REVISION_TERMINAL</td>
                            <td>Maximum 4 characters</td>
                            <td>No</td>
                            <td>0001</td>
                        </tr>
                        <tr>
                            <td>ABT_JOIN</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>*</td>
                        </tr>
                        <tr>
                            <td>CODE_XVAL</td>
                            <td>Maximum 10 characters</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>CODE_XDESC</td>
                            <td>Maximum 64 characters</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>HELP_DESC</td>
                            <td>Character string of unknown length</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>DETAILFLAG</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>DISTRIBUTION_RODER</td>
                            <td>Maximum 3 characters</td>
                            <td>No</td>
                            <td>000</td>
                        </tr>
                        <tr>
                            <td>COURSE_CREDIT_BASE</td>
                            <td>Decimal number of 18 numbers and 6 right of decimal</td>
                            <td>Yes</td>
                            <td>0.000000</td>
                        </tr>
                        <tr>
                            <td>OVERLOAD</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>FIN_AID_UPLOAD</td>
                            <td>Maximum 10 characters</td>
                            <td>Yes</td>
                            <td>8175</td>
                        </tr>
                        <tr>
                            <td>AID_FEE_PERCT_FLAT</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>AID_FEE_FLAT_AMT</td>
                            <td>Decimal number of 18 numbers and 6 right of decimal</td>
                            <td>No</td>
                            <td>0.000000</td>
                        </tr>
                        <tr>
                            <td>AID_FEE_PERCENTAGE</td>
                            <td>Decimal number of 6 numbers and 3 right of decimal</td>
                            <td>No</td>
                            <td>0.000</td>
                        </tr>
                        <tr>
                            <td>ASSOC_FIN_AID_CODE</td>
                            <td>Maximum 10 characters</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>LATE_OR_INT_FEE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <td>LATE_OR_INT_PERCT</td>
                            <td>Decimal number of 6 numbers and 3 right of decimal</td>
                            <td>No</td>
                            <td>0.000</td>
                        </tr>
                        <tr>
                            <td>PAYMENT_OPTION</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>Y</td>
                        </tr>
                        <tr>
                            <td>PAYPLAN_ELIGIBLE</td>
                            <td>Single character</td>
                            <td>No</td>
                            <td>Y</td>
                        </tr>
                        <tr>
                            <td>TYPE_1098</td>
                            <td>Single character</td>
                            <td>Yes</td>
                            <td>S</td>
                        </tr>
                        <tr>
                            <td>ChargeCreditCodeId</td>
                            <td>Integer number</td>
                            <td>No</td>
                            <td>7868</td>
                        </tr>
                        <tr>
                            <td>LateFeeProfileId</td>
                            <td>Integer number</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>TaxProfileId</td>
                            <td>Integer number</td>
                            <td>Yes</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>IsATax</td>
                            <td>Yes/No binary</td>
                            <td>No</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>IsTitleIV</td>
                            <td>Yes/No binary</td>
                            <td>No</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>IsPrivateLoan</td>
                            <td>Yes/No Binary</td>
                            <td>No</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>IsInstitutionalDebt</td>
                            <td>Yes/No binary</td>
                            <td>No</td>
                            <td>0</td>
                        </tr>
                    </tbody>
                </Table>

                {/*{<div style={{ height: 650 }}>*/}
                {/*    <GridExample*/}
                {/*        queryToRun={1}*/}

                {/*    />*/}
                {/*</div>}*/}
            </ModalBody>
        </Modal>
        <h3>Fund Token Management</h3><br />
            {/*{<div style={{ height: 650 }}>*/}
            {/*    <GridExample*/}
            {/*        queryToRun={1}*/}

            {/*    />*/}
        {/*</div>}*/}
        <div className="halfOfParent"><Input type='file' accept=".csv" onChange={(e) => fileSelect(e)} /></div><br />
        <Button onClick={submitFile} id={"showMe"}>Submit</Button>&ensp; {fileResponse != "" && <span color="#008000">{fileResponse}</span>}<br />
        <Button onClick={toggleModal}>Table Field Information</Button>
        <Tooltip placement={'top'} target={"showMe"} toggle={toggle} isOpen={tooltipOpen}>Pressing this button will immdediately import the data into PowerCampus. <p />
            Be sure to triple check to ensure the data is exactly matching what you want and what PowerCampus expects. There will not be an opportunity to change it after this button is pressed before it enters PowerCampus.</Tooltip>

        </div>)
    
}

export default FundToken;